module.exports = __webpack_public_path__ + "static/media/document-photo-placeholder.358b203e.svg";